export default [
  {
    header: 'Вопросы',
    resource: 'questions',
    action: 'view',
  },
  {
    title: 'Список вопросов',
    route: 'questions',
    icon: 'HelpCircleIcon',
    tagVariant: 'light-warning',
    resource: 'questions',
    action: 'view',
  },
]
